





































import { Vue, Component } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { routeTo } from '@/api/reactor/reactions';

@Component({
    validations: {
        form: {
            name: {
                required
            },
        }
    },
    reactions: {
      '$links/startLinkCreated': routeTo((ctx) => {
          return { name: 'links', params: ctx.$route.params};
      })
    }
})
export default class LinkForm extends Vue {
  form: any = {
    destinationId: '',
    name: ''
  };
  loading: boolean = false;

  get nameErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.name) {
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push('Name is required.');
    }
    return errors
  }
  
  async mounted() {
    await this.$store.dispatch('$destinations/select', this.$route.params.did);
    this.form.destinationId = this.$route.params.did;
  }

  async onSubmit() {
    this.loading = true;
    await this.$store.dispatch('$links/create', this.form);
    this.loading = false;
  }
}
